// extracted by mini-css-extract-plugin
module.exports = {"centeredDiv":"loadingComponent__centeredDiv__665c60a8"};